/**
 * 营销推广
 */

import ajax from '@/utils/ajax'


/**
 * 营销中心绑定
 */

// 提交用户信息
export const submitInfo = params => ajax.post('market/submit', params)

// 轮询扫码状态接口
export const queryQrCodeStatus = params => ajax.post('market/heartbeat4QrCode', params)

// 刷新二维码
export const refreshQrcode = params => ajax.post('market/getQrCode', params)

// 获取当前参加商户数，和油站是否已经参加
export const marketCenter = params => ajax.post('/market/marketCenter', params)

// 油站是否参加活动
export const involved = params => ajax.post('/market/involved', params)

export const canJoin = params => ajax.post('/market/canJoin', params)
/**
 * 我的营销
 */
// 活动状态枚举
export const getActiveList = params => ajax.post('market/approvalStatus', params)

// 查询活动记录
export const activeRecord = params => ajax.post('market/queryWithPage', params)

/**
 * 限时秒杀，天天特价接口
 * */ 

// 活动标签接口
export const activityLabel = params => ajax.post('activity/activityLabel', params)

// 油站个数接口
export const joinCompanyNum = params => ajax.post('activity/joinCompanyNum', params)

// 是否签署电子协议
export const check = params => ajax.post('activity/check', params)

// 点击同意签署电子协议
export const accept = params => ajax.post('activity/accept', params)

// 列表数据，和送水是两套列表
export const checkList = params => ajax.post('activity/checkList', params)

// 撤回接口
export const withdrawal = params => ajax.post('activity/withdrawal', params)

// 同意接口
export const agree = params => ajax.post('activity/agree', params)

// 驳回接口
export const reject = params => ajax.post('activity/reject', params)

// 待审批单据数量
export const formNum = params => ajax.post('activity/approveNum', params)

// 获取营销列表详情接口
export const operateDetail = params => ajax.post('activity/operateDetail', params)

// 是否有油站关系接口
export const checkGasSale = params => ajax.post('activity/checkGasSale', params)

// 获取营销送水接口
export const deliverWaterDetail = params => ajax.post('market/deliverWaterDetail', params)

// 送水活动起始时间查询
export const checkDate = params => ajax.post('common/enableChooseTimeRange', params)

// 审核列表活动类型枚举接口
export const getActivityTypeList = params => ajax.post('activity/getActivityTypeList', params)

// 会员-精准营销活动参加油站的数量
export const persisGasNum = params => ajax.post('/marketTask/gasNum', params)

// 抽奖宝-营销中心活动菜单展示权限
export const getMarketingCenter = params => ajax.post('/luckyDraw/getMarketingCenter', params)

// 抽奖宝-抽奖宝图片和形容
export const getLuckyDrawPic = params => ajax.post('/luckyDraw/getLuckyDrawPic', params)

// 抽奖宝-抽奖宝油站数量
export const getLuckDrawApplicantsCount = params => ajax.post('/luckyDraw/getLuckDrawApplicantsCount', params)

// 抽奖宝-展示页奖品详情
export const getEffectiveLuckDrawByGasId = params => ajax.post('/luckyDraw/getEffectiveLuckDrawByGasId', params)

// 抽奖宝-按钮展示逻辑
export const getActivityStatus = params => ajax.post('/luckyDraw/getActivityStatus', params)

// 抽奖宝-详情接口
export const operateDetailForDraw = params => ajax.post('/activity/operateDetailForDraw', params)

// 获取蓝团二维码
export const getBlueQRcode = params => ajax.post('/luckyDraw/getBlueQRcode', params)

// 获取蓝团二维码
export const getAgreementValue = params => ajax.post('/luckyDraw/getAgreementValue', params)

// 获取蓝团二维码
export const signUp = params => ajax.post('/luckyDraw/signUp', params)

// 获取md信息
export const getMdByGas = params => ajax.post('/luckyDraw/getMdByGas', params)

// 获取md信息
export const getLastAddress = params => ajax.post('/luckyDraw/getLastAddress', params)


/**
 * 商户冲单展示页接口
 * */ 
// 活动预览页展示
export const previewOrder = params => ajax.post('/offsetOrder/preview', params)


// 是否可以参加
export const canJoinOrder = params => ajax.post('/offsetOrder/canJoin', params)

// 增长计划详情
export const growthPlanDetail = params => ajax.post('/merchantMarket/previewNew', params)

// 增长计划报名
export const growthPlanSignup = params => ajax.post('/merchantMarket/signup', params)

// 路程补贴列表
export const querySignUpGasConfigList = params => ajax.post('/fullCoupon/querySignUpGasConfigList', params)

// 参与路程补贴
export const journeySignup = params => ajax.post('/fullCoupon/signup', params)

// 燎原活动广场
export const marketCenterList = params => ajax.post('/market/marketCenterList', params)

// 获取燎原活动列表
export const queryLiaoyuanGasConfigList = params => ajax.post('/liaoyuan/querySignUpGasConfigList', params)

// 是否参与燎原活动
export const liaoyuanSignup = params => ajax.post('/liaoyuan/signup', params)
